import React, { Component } from 'react'
import '../Common.scss';
import defaultImage from '../../../assets/default.png';

export default class SiteDetail extends Component<any,any> {
  render() {
    const { pageDetails } = this.props;
    const { elevationImage, siteDetail} = pageDetails;
   // console.log(siteDetail);
    return (
     <React.Fragment>
          <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage?.imageUrl ? `${elevationImage?.imageUrl}` :defaultImage} alt="" className="image-view" />
                    </div>
          </div>
          <div className="details-tables">
                    <div className="table-header">
                        <div className="details-heading-wrapper details-heading">
                            SITE DETAILS
                        </div>
                        <div className='details'>
                        {
                        Object.keys(siteDetail)?.map( (key) => {
                            const detail = siteDetail[key];
                            if(detail){
                                return (
                                    <React.Fragment>
                                        <div className="details-table">
                                            <React.Fragment>
                                                {
                                                    detail.map((property,index) =>{
                                                        return (
                                                            <React.Fragment key={index}>
                                                                {
                                                                        <div className="table-row">
                                                                            <div className="table-cell">
                                                                                {property['key']}
                                                                            </div>
                                                                            <div className="table-cell">
                                                                                {property['value']}
                                                                            </div>
                                                                        </div>
                                                                }
                                                            </React.Fragment>
                                                       )

                                                    })
                                                }
                                            </React.Fragment>
                                        </div>

                                    </React.Fragment>

                                
                                )
                            }
                        
                        })
                        }
                        </div>
                    </div>
          </div>
     </React.Fragment>
    )
  }
}